export default __webpack_public_path__ + "static/media/package.1b555a7f.svg";